import ASelectField from './index.vue';

ASelectField.install = app => {
  app.component(ASelectField.name, ASelectField);
};

export default ASelectField;
